document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('.header__inline-menu');
  if (!container) return;

  container.addEventListener('pointermove', function (event) {
    var rect = container.getBoundingClientRect();
    container.style.setProperty('--spot-x', (event.clientX - rect.left) + 'px');
    container.style.setProperty('--spot-y', (event.clientY - rect.top) + 'px');
  });
});
